import { render, staticRenderFns } from "./menucolonneverte_contacts_header.vue?vue&type=template&id=9c8987c2"
import script from "./menucolonneverte_contacts_header.js?vue&type=script&lang=js&external"
export * from "./menucolonneverte_contacts_header.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports